import styles from "./index.module.less";
import avatar from "./imgs/avatar.png";
import KefuIcon from "./imgs/kefu_icon.svg?react";
import Line from "./imgs/line.svg?react";
import { observer } from "mobx-react";
import { useStore } from "@/stores";
import { Flex, Space } from "antd";
import Agent from "../Agent";
import { useState } from "react";
import classNames from "classnames";
import SVGIcon from "../SVGIcon";
import { isMobile } from "@/utils";
import MobileKefu from "./mobile";

const Kefu = () => {
  const appStore = useStore("app");
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.kefu}>
      <div className={styles.kefuInner}>
        <img src={avatar} alt="客服头像" />
      </div>
      <div className={styles.menusWrap}>
        <Flex
          vertical
          align="center"
          justify="space-between"
          className={styles.menus}
        >
          <Flex vertical align="center" className={styles.agent} onClick={() => setOpen(true)}>
            <SVGIcon icon={<KefuIcon />} width={24} />
            
            <span>在线咨询</span>
          </Flex>
          <div className={styles.line}>
            <Line />
          </div>
          <div
            className={styles.contact}
            onClick={() => {
              appStore.openContactModal();
            }}
          >
            联系我们
          </div>
        </Flex>
      </div>
      <div className={classNames(styles.agentWrap, { [styles.open]: open })}>
        <Agent open={open} onClose={() => {
          console.log('close')
            setOpen(false)
        }} />
      </div>
    </div>
  );
};
export default isMobile() ? MobileKefu : observer(Kefu);
